export const isUUID = (value) => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
};

const TEMPLATE_GROUP_PREFIX = "templateGroup:";

export const isTemplateGroup = (value) =>
  typeof value === "string" &&
  value.startsWith(TEMPLATE_GROUP_PREFIX);

export const getTemplateGroupUuid = (value) =>
  value?.slice(TEMPLATE_GROUP_PREFIX.length);

export const toTemplateGroupValue = (uuid) =>
  `${TEMPLATE_GROUP_PREFIX}${uuid}`;

export const JOB_TYPE_KIND = {
  TEMPLATE_GROUP: "templateGroup",
  TEMPLATE: "template",
  DEFAULT: "default",
};

export function parseJobType(value) {
  if (isTemplateGroup(value)) {
    return {
      kind: JOB_TYPE_KIND.TEMPLATE_GROUP,
      jobType: null,
      templateUuid: null,
      templateGroupUuid: getTemplateGroupUuid(value),
    };
  }
  if (isUUID(value)) {
    return {
      kind: JOB_TYPE_KIND.TEMPLATE,
      jobType: "template",
      templateUuid: value,
      templateGroupUuid: null,
    };
  }
  return {
    kind: JOB_TYPE_KIND.DEFAULT,
    jobType: value || "medical_record",
    templateUuid: null,
    templateGroupUuid: null,
  };
}
